import { translateValueMetric } from 'utils/common'

export const renderLineLegend = (props: any) => {
  const { payload } = props

  return (
    <ul className='flex justify-center gap-4'>
      {payload.map((entry: any, index: number) => {
        return (
          <li key={`item-${index}`} className='flex gap-2 text-[10px] flex-col items-center justify-between'>
            <span
              className={'w-[56px] h-[2px] min-h-[2px] rounded-sm'}
              style={{
                background: entry.color
              }}
            />
            <span className='font-[450] text-[10px] h-full text-neutral-300'>{translateValueMetric(entry.value)}</span>
          </li>
        )
      })}
    </ul>
  )
}
